import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Divider, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import variable from '../../scss/variables.scss'

interface IProps {
  isShow: boolean
  size?: DialogProps['maxWidth']
  title: React.ReactNode | string
  content?: React.ReactNode
  actions?: React.ReactNode
  highlightedActions?: boolean
  onClose: () => void
  testPrefix: string
  isDivider?: boolean
  isBottomDivider?: boolean
  minHeight?: string
}

export const IQDialog = ({
  isShow,
  size = 'sm',
  title,
  content,
  actions,
  onClose,
  testPrefix,
  highlightedActions = false,
  isDivider = false,
  isBottomDivider = false,
  minHeight,
}: IProps) => (
  <Dialog
    open={isShow}
    fullWidth
    disableEscapeKeyDown={true}
    maxWidth={size}
    sx={{
      ...(minHeight && {
        '& .MuiDialogContent-root > .MuiBox-root': {
          minHeight,
        },
      }),
    }}
    onClose={onClose}
  >
    <>
      <DialogTitle
        sx={{
          pr: 6,
        }}
        data-testid={`${testPrefix}-title`}
      >
        {title}
      </DialogTitle>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          mr: 1,
          mt: 1,
        }}
        data-testid={`${testPrefix}-close`}
      >
        <Close />
      </IconButton>
      {isDivider && <Divider sx={{ mr: 3, ml: 3, mb: 2 }} />}
    </>
    {content ? <DialogContent sx={{ pt: 0 }}>{content}</DialogContent> : <></>}
    {isBottomDivider && <Divider sx={{ mr: 3, ml: 3, mb: 2 }} />}
    <DialogActions sx={{ px: 2, py: 2, backgroundColor: highlightedActions ? variable.base200 : '' }}>{actions}</DialogActions>
  </Dialog>
)
